module.exports = __webpack_public_path__ + "img/chick.3ec830cc.jpg";